/**
 * 9 - общепризнаный в компании id для идентификации студий
 */
export function isStudio(roomsCount: number) {
  return roomsCount === 9;
}
